{
  "firmwares": {
    "navigation_title": "Firmware",
    "title": "Firmware",
    "empty_list": "No hay firmwares disponibles",
    "rollout": "Implementar firmware",
    "select_channel": "Seleccionar canal...",
    "select_serials": "Seleccionar número de serie..."
  }
}
